import { PiDiamondsFourBold } from "react-icons/pi";
import SectionHead from "./SectionHead";
// import { Link } from "react-router-dom";
import './Classes.css'

const Classes = () => {
  return (
    <div className="container classes-container">
      <SectionHead icon={<PiDiamondsFourBold />} title="Classes" />

      <div className="classes__columns">

        <div className='classes__column classes__column--left'>
          <h3 className="classes__column-title">In-Person Classes</h3>
          <p className="classes__column-body">
            For the first time since the pandemic, we're having in-person classes
            3 times a week at Journey into Fitness.
          </p>
          <address className="classes__details">
            1799 Central Avenue<br />
            St Petersburg, FL 33712<br />
            <br />
            Monday &amp; Friday at 10am<br />
            Wednesday at 5:30pm
          </address>
        </div>

        <div className="classes__divider" aria-hidden="true" />

        <div className="classes__column">
          <h3 className="classes__column-title">Online Classes</h3>
          <p className="classes__column-body">
            Every weekend, the regular classes that got you through the pandemic
            are continuing to help you ignite your home practice.
          </p>
          <p className="classes__details">
            Join us online.<br />
            <br />
            Saturday at 8:15am<br />
            Sunday at 10am
          </p>
        </div>

      </div>

     <p className="classes__cta">
     Click on the calendar below to book your next class.{" "}
     <a href="/student-guide.pdf" 
     target="_blank" 
     rel="noreferrer" 
     className="classes__guide-link">
     New here? Download the Student Guide →</a>
     </p>
    </div>
  );
}

export default Classes;
